export function overlay(state = {}, action) {
  switch (action.type) {
    case 'OPEN_OVERLAY':
      return { ...state, ...{ blob: action.overlayAction } };
    case 'CLOSE_OVERLAY': {
      return {};
    }
    default:
      return state;
  }
}
